import Model, { attr } from '@ember-data/model';

export default class UserSettingModel extends Model {
  @attr('boolean') declare hideMaps: boolean;
  @attr('boolean') declare showAnnualGoal: boolean;
  @attr('boolean') declare hasCreditCard: boolean;
  @attr('string') declare dateFormat: string;
  @attr('boolean') declare showUserLastLogin: boolean;
  @attr('boolean') declare showUploadFiles: boolean;
  @attr() customReports: any;
}
